import { cn } from "@/lib/utils";

// White/red split-word treatment, e.g. TRILOGY + APP
// Left word inherits the surrounding text color (so it stays white inside dark
// sections even in light mode); right word uses the brand red accent.
export const SplitWord = ({ left, right, className, leftClassName, rightClassName }) => {
  return (
    <span className={cn("inline-flex items-baseline", className)}>
      <span className={cn(leftClassName)}>{left}</span>
      <span className={cn("text-brand", rightClassName)}>{right}</span>
    </span>
  );
};
